import { createCheckedItemsKey, parseCheckedItems } from "./keys";
import { localStorageKeys } from "../constants";

/**
 * Used to update list of checked items in local storage.
 * @param {Set} state - the set 'userCheckedItems' held in state
 * @param {String} key - the ${sublistId}-{itemId} for the just-checked/unchecked item
 * @returns {undefined}
 */
export const updateStorage = (state, key) =>
    localStorage.setItem(localStorageKeys.BTC_LOCAL_STORAGE_KEY, createCheckedItemsKey(state, key));

export const getUserCheckedItemsFromStorage = () => {
    const storage = localStorage.getItem(localStorageKeys.BTC_LOCAL_STORAGE_KEY);
    return storage ? parseCheckedItems(storage) : new Set();
};
